/**
 * v1.4 畫面風格：新版（陰影、發光、圓角、統一色票、奶油色介面）／經典版（v1.3 原本的樣子）。
 * - 只影響外觀，遊戲規則、存檔、小遊戲邏輯完全一樣。
 * - 網址 `?style=classic`／`?style=new` 可以直接指定；選單「🎨 畫面風格」切換後會記在這台瀏覽器（localStorage）並重新整理。
 * - 預設：新版。
 */
export type ArtStyle = 'new' | 'classic';
const KEY = 'ffg.style';

let cached: ArtStyle | null = null;
export function artStyle(): ArtStyle {
  if (cached) return cached;
  let s: string | null = null;
  try { s = new URLSearchParams(globalThis.location?.search ?? '').get('style'); } catch { /* ignore */ }
  if (s !== 'new' && s !== 'classic') { try { s = globalThis.localStorage?.getItem(KEY) ?? null; } catch { s = null; } }
  cached = s === 'classic' ? 'classic' : 'new';
  return cached;
}
export const isNewStyle = () => artStyle() === 'new';

/** 開機時呼叫：<html> 加上 style-new／style-classic，CSS 用它切換介面樣式 */
export function applyArtStyleClass(): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.classList.toggle('style-new', isNewStyle());
  root.classList.toggle('style-classic', !isNewStyle());
}

/** 切換風格：記住選擇、拿掉網址上的 ?style=、重新整理（3D 場景要重建） */
export function setArtStyle(s: ArtStyle, reload = true): void {
  try { localStorage.setItem(KEY, s); } catch { /* ignore */ }
  cached = s;
  if (!reload || typeof location === 'undefined') return;
  const q = location.search.replace(/([?&])style=[^&]*(&|$)/, '$1').replace(/[?&]$/, '');
  location.replace(location.pathname + q + location.hash);
}
